import { Position, MarkerType } from '@vue-flow/core';

export const AgentFlowSimple = {
  intents: [
    {
      id: 'Intent1',
      name: 'Intent1',
      task: 'Task1',
    },
    {
      id: 'Intent2',
      name: 'Intent1',
    },
    {
      id: 'Intent3',
      name: 'Intent1',
      task: 'Task2',
      parentId: 'Intent2',
    },
    {
      id: 'Intent4',
      name: 'Intent1',
      parentId: 'Intent2',
    },
  ],
  tasks: [
    {
      id: 'Task1',
      name: 'Task1',
      success: 'Task3', // Move to Task3 task if this one completed successfully
      error: 'Task2', // Move to Task2 task if this one failed
    },
    {
      id: 'Task2',
      name: 'Task2',
      success: null,
      error: null,
    },
    {
      id: 'Task3',
      name: 'Task3',
      success: null,
      error: null,
    },
  ],
};

export const AgentFlowGraphSimple = [
  // nodes
  { id: 'Intent1', label: 'Intent1', type: 'nodeIntent' },
  { id: 'Intent2', label: 'Intent2', type: 'nodeIntent' },
  { id: 'Intent3', label: 'Intent3', type: 'nodeIntent' },
  { id: 'Intent4', label: 'Intent4', type: 'nodeIntent' },
  { id: 'Task1', label: 'Task1', type: 'nodeTask' },
  { id: 'Task2', label: 'Task2', type: 'nodeTask' },

  // Edges
  { id: 'Intent1-Task1', source: 'Intent1', target: 'Task1' },
  { id: 'Intent2-Intent3', source: 'Intent2', target: 'Intent3' },
  { id: 'Intent2-Intent4', source: 'Intent2', target: 'Intent4' },
  { id: 'Intent3-Task2', source: 'Intent3', target: 'Task2' },
  { id: 'Task1-Task3', source: 'Task1', target: 'Task3', sourceHandle: 'success' },
  { id: 'Task1-Task2', source: 'Task1', target: 'Task2', sourceHandle: 'error' },
];

export const AgentFlowQA = {
  intents: [
    {
      id: 'QUESTION',
      name: 'Request for Information or Help',
      definition: 'The user is asking for factual or additional details about a specific topic, assistance or guidance to solve a problem or perform a task.',
      examples: '"What are your hours of operation?", "Can you tell me more about your product’s features?", "How do I set this up?", "I need help troubleshooting my printer."',
      task: 'TaskAnswer',
    },
    {
      id: 'ESCALATION',
      name: 'Request for Agent or Live Person',
      definition: 'The user is demanding to be connected to an agent, supervisor or live person.',
      examples: '"Connect me to an agent", "Human", "I need to talk to supervisor", "I want to speak to a live person."',
      task: 'TaskCollectData',
    },
  ],
  tasks: [
    {
      id: 'TaskAnswer',
      name: 'Answer Questions',
      success: null, // No next task if this one completed successfully
      error: null, // Move to handoff task if this one failed
    },
    {
      id: 'TaskHandoff',
      name: 'Handoff',
      success: null,
      error: null,
    },
    {
      id: 'TaskCollectData',
      name: 'Collect Contact Data',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Name', icon: 'text' },
        { name: 'Email', icon: 'text' },
        { name: 'Phone', icon: 'text' },
      ],
    },
  ],
};

export const AgentFlowQAS = {
  intents: [
    {
      id: 'QUESTION',
      name: 'Request for Information or Help',
      definition: 'The user is asking for factual or additional details about a specific topic, assistance or guidance to solve a problem or perform a task.',
      examples: '"What are your hours of operation?", "Can you tell me more about your product’s features?", "How do I set this up?", "I need help troubleshooting my printer."',
      task: 'TaskAnswer',
    },
    {
      id: 'ORDER',
      name: 'Order status Inquiry',
      definition: 'The user is asking to check status of their order',
      examples: '"Where is my order?"',
      task: 'TaskCheckOrder',
    },
    {
      id: 'ESCALATION',
      name: 'Request for Agent or Live Person',
      definition: 'The user is demanding to be connected to an agent, supervisor or live person.',
      examples: '"Connect me to an agent", "Human", "I need to talk to supervisor", "I want to speak to a live person."',
      task: 'TaskCollectData',
    },
  ],
  tasks: [
    {
      id: 'TaskAnswer',
      name: 'Answer Questions',
      success: null, // No next task if this one completed successfully
      error: null, // Move to handoff task if this one failed
    },
    {
      id: 'TaskHandoff',
      name: 'Handoff',
      success: null,
      error: null,
    },
    {
      id: 'TaskCheckOrder',
      name: 'Order Status',
      definition: 'Check order status in Shopify',
      success: null,
      error: null,
    },
    {
      id: 'TaskCollectData',
      name: 'Collect Contact Data',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Name', icon: 'text' },
        { name: 'Email', icon: 'text' },
        { name: 'Phone', icon: 'text' },
      ],
    },
  ],
};

export const AgentFlowGoHealth = {
  intents: [
    {
      id: 'i1',
      name: 'Plan materials',
      definition: 'Member is looking for plan materials/plan card',
      task: 'c1',
    },
    {
      id: 'i2',
      name: 'General plan information',
      definition: 'Member looking for general plan information',
      task: 'c2',
    },
    {
      id: 'i3',
      name: 'Benefit advertisement',
      definition: 'Member is asking about a benefit they saw in an advertisement',
      task: 'c3',
    },
    {
      id: 'i4',
      name: 'Speak to agent of record',
      definition: 'Member wants to speak to agent of record',
      task: 'c4',
    },
    {
      id: 'i5',
      name: 'Member is deceased',
      definition: 'Member is deceased',
      task: 'c5',
    },
    {
      id: 'i6',
      name: 'Member Action Plan for Anthem',
      definition: 'Member wants to complete Member Action Plan for Anthem.',
      task: 'c6',
    },
    {
      id: 'i7',
      name: 'Plan On-boarding',
      definition: 'Plan On-boarding',
      task: 'c7',
    },
    {
      id: 'i8',
      name: 'Cancellation',
      definition: 'Cancellation',
      task: 'c8',
    },
    {
      id: 'QUESTION',
      name: 'Questions about medicare',
      definition: 'User is asking questions about medicare',
      task: 'TaskAnswer',
    },
  ],
  tasks: [
    {
      id: 'TaskAnswer',
      name: 'Answer Questions',
      success: null,
      error: null,
    },
    {
      id: 'TaskHandoff',
      name: 'Handoff',
      success: null,
      error: null,
    },
    {
      id: 'c1',
      name: 'Collect Data',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Carrier', icon: 'text' },
        { name: 'Month Since Enrolled', icon: 'text' },
        { name: 'Reason: Plan Materials', icon: 'text' },
      ],
    },
    {
      id: 'c2',
      name: 'Collect Carrier',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Carrier', icon: 'text' },
        { name: 'Reason: General Plan Info', icon: 'text' },
      ],
    },
    {
      id: 'c3',
      name: 'Collect Carrier',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Carrier', icon: 'text' },
        { name: 'Reason: Ads', icon: 'text' },
      ],
    },
    {
      id: 'c4',
      name: 'Collect Agent Extension',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Agent Extension', icon: 'text' },
        { name: 'Reason: AOR Transfer', icon: 'text' },
      ],
    },
    {
      id: 'c5',
      name: 'Message',
      success: 'TaskHandoff',
      definition: 'First, you must say that that you are sorry for the loss, expressing the great empathy. Say that you will connect user to someone who can prevent additional contact from being made.',
      error: 'null', // Move to handoff task if this one failed
      items: [{ name: 'Reason: Deceased', icon: 'text' }],
    },
    {
      id: 'c6',
      name: 'Confirm if Anthem',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Anthem', icon: 'text' },
        { name: 'Reason: MAP', icon: 'text' },
      ],
    },
    {
      id: 'c7',
      name: 'Collect Carrier',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Carrier', icon: 'text' },
        { name: 'Reason: Plan Onboarding', icon: 'text' },
      ],
    },
    {
      id: 'c8',
      name: 'Collect Carrier',
      success: 'TaskHandoff',
      error: 'null', // Move to handoff task if this one failed
      items: [
        { name: 'Carrier', icon: 'text' },
        { name: 'Reason: Cancellation', icon: 'text' },
      ],
    },
  ],
};

export const AgentFlow1 = {
  intents: [
    {
      id: 'QUESTION',
      name: 'Request for Information or Help',
      definition: 'The user is asking for factual or additional details about a specific topic, assistance or guidance to solve a problem or perform a task.',
      examples: '"What are your hours of operation?", "Can you tell me more about your product’s features?", "How do I set this up?", "I need help troubleshooting my printer."',
      task: 'TaskAnswer',
    },
    {
      id: 'ECOMMERCE',
      name: 'E-commerce related Inquiry',
      definition: 'The user is asking e-commerce related questions, such as order status, inventory, etc.',
      examples: '"Where is my order?"',
    },
    {
      id: 'ESCALATION',
      name: 'Request for Agent or Live Person',
      definition: 'The user is demanding to be connected to an agent, supervisor or live person.',
      examples: '"Connect me to an agent", "Human", "I need to talk to supervisor", "I want to speak to a live person."',
      task: 'TaskHandoff',
    },
    {
      id: 'ORDER_CANCEL',
      name: 'Cancel Order',
      definition: 'The user is asking to cancel order',
      examples: '"I need to cancel my order"',
      task: 'TaskCollectOrderNumber',
      parentId: 'ECOMMERCE',
    },
    {
      id: 'INVENTORY',
      name: 'Inventory Inquiry',
      definition: 'The user is asking about what is in stock',
      examples: '"Do you have this in stock?"',
      task: 'TaskShowInventory',
      parentId: 'ECOMMERCE',
    },
  ],
  tasks: [
    {
      id: 'TaskAnswer',
      name: 'Answer Questions',
      success: null, // No next task if this one completed successfully
      error: 'TaskHandoff', // Move to handoff task if this one failed
    },
    {
      id: 'TaskHandoff',
      name: 'Handoff',
      success: null,
      error: null,
    },
    {
      id: 'TaskCollectOrderNumber',
      name: 'Collect Data',
      success: 'TaskCancelOrder', // Move to cancel order task if this one completed successfully
      error: 'TaskHandoff', // Move to handoff task if this one failed
      items: [
        {
          name: 'Order Number',
          icon: 'text',
        },
      ],
    },
    {
      id: 'TaskCancelOrder',
      name: 'Cancel Order',
      success: null,
      error: 'TaskHandoff', // Move to handoff task if this one failed
    },
    {
      id: 'TaskShowInventory',
      name: 'Show inventory',
      success: null,
      error: 'TaskHandoff', // Move to handoff task if this one failed
    },
  ],
};

/**
 * Converts a flow definition (with `intents` and `tasks`) into
 * a combined array of graph nodes and edges for visualization.
 *
 * @param {Object} flow - The flow object containing `intents` and `tasks`.
 * @return {Array} An array of nodes and edges suitable for a graph definition.
 */
export function convertFlowToGraph(flow) {
  const { intents = [], tasks = [] } = flow;

  const graph = {
    intents: {},
    tasks: {},
    nodes: [],
    edges: [],
  };

  // Add start node
  graph.nodes.push({
    id: 'start',
    type: 'input',
    sourcePosition: Position.Right, // or Top, Left, Right,
    data: { label: 'Start' },
    position: { x: 0, y: 0 },
  });

  // 1. Convert each intent into a node.
  intents.forEach((intent) => {
    graph.nodes.push({
      id: intent.id,
      label: intent.id, // or intent.name if you'd prefer
      type: 'nodeIntent',
      data: intent,
      position: { x: 0, y: 0 },
    });
    graph.intents[intent.id] = intent;
  });

  // 2. Convert each task into a node.
  tasks.forEach((task) => {
    graph.nodes.push({
      id: task.id,
      label: task.id, // or task.name if you'd prefer
      type: 'nodeTask',
      data: task,
      position: { x: 0, y: 0 },
    });
    graph.tasks[task.id] = task;
  });

  // 3. Build edges from intents.
  intents.forEach((intent) => {
    if (!intent.parentId) {
      // Add edge from start node to top level intent
      graph.edges.push({
        id: `start-${intent.id}`,
        source: 'start',
        target: intent.id,
        markerEnd: MarkerType.ArrowClosed,
        //type: 'smoothstep',
      });
    } else {
      // If this intent has parent, draw edge from parent to child.
      graph.edges.push({
        id: `${intent.parentId}-${intent.id}`,
        source: intent.parentId,
        target: intent.id,
        markerEnd: MarkerType.ArrowClosed,
        //type: 'smoothstep',
      });
    }

    // If this intent has a linked task, draw an edge.
    if (intent.task) {
      graph.edges.push({
        id: `${intent.id}-${intent.task}`,
        source: intent.id,
        target: intent.task,
        markerEnd: MarkerType.ArrowClosed,
        //type: 'smoothstep',
      });
    }
  });

  // 4. Build edges from tasks.
  tasks.forEach((task) => {
    // If this task has a success target, draw an edge with sourceHandle = 'success'.
    if (task.success) {
      graph.edges.push({
        id: `${task.id}-${task.success}`,
        source: task.id,
        target: task.success,
        sourceHandle: 'success',
        markerEnd: MarkerType.ArrowClosed,
        //type: 'smoothstep',
      });
    }

    // If this task has an error target, draw an edge with sourceHandle = 'error'.
    if (task.error) {
      graph.edges.push({
        id: `${task.id}-${task.error}`,
        source: task.id,
        target: task.error,
        sourceHandle: 'error',
        markerEnd: MarkerType.ArrowClosed,
        //type: 'smoothstep',
      });
    }
  });

  return graph;
}

// Convert graph to agent flow
